@use "Styles/mixins";

:host {
    position: fixed;
    z-index: mixins.get-z(toast-component, container);
    display: block;

    // Mobile: bottom center
    bottom: 8px;
    left: 50%;
    transform: translateX(-50%);

    @include mixins.desktop-and-up {
        // Desktop: bottom right
        bottom: 36px;
        left: auto;
        right: 24px;
        transform: none;
    }
}

.vm-toast-container {
    &__list {
        display: flex;
        flex-direction: column;
        gap: 8px;
    }
}
